import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { IhmConfiguration, IHM_CONFIG, IHM_CONFIG_NAME } from './ihm-configuration.model';
import { IhmConfigurationService } from './ihm-configuration.service';

export function configInitializer(service: IhmConfigurationService<IhmConfiguration>): () => Promise<void> {
  return (): Promise<void> => service.initialize();
}

// @dynamic
@NgModule({
  imports: [HttpClientModule]
})
export class IhmConfigurationModule {
  public static initConfig(applicationName: string, config?: IhmConfiguration): ModuleWithProviders {
    return {
      ngModule: IhmConfigurationModule,
      providers: [
        IhmConfigurationService,
        { provide: IHM_CONFIG_NAME, useValue: applicationName },
        { provide: IHM_CONFIG, useValue: config },
        {
          provide: APP_INITIALIZER,
          useFactory: configInitializer,
          multi: true,
          deps: [IhmConfigurationService]
        }
      ]
    };
  }
}
